import * as React from "react";
import * as styles from "./styles";
import { FormattedDate } from "react-intl";

interface IProps {
  event: { start: string };
}

const TicketDate: React.FC<IProps> = (props: IProps) => {
  const { event } = props;
  return (
    <React.Fragment>
      <div className={styles.dateWrapper}>
        <div className={styles.day}>
          <FormattedDate value={event.start} day="numeric" />
        </div>
        <div className={styles.month}>
          <FormattedDate value={event.start} month="short" />
        </div>
        <div className={styles.year}>
          <FormattedDate value={event.start} year="numeric" />
        </div>
      </div>
    </React.Fragment>
  );
};

export default TicketDate;
